export const API_URL = ' https://forkify-api.herokuapp.com/api/v2/recipes/';
// 'https://forkify-api.herokuapp.com/api/v2/recipes/5ed6604591c37cdc054bcf7e'
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '85cf70d3-e40a-4a0a-9267-dc77f23d637c';
export const MODAL_CLOSE_SEC = 2.5;
